export const baseUrl = 'https://abogados-control-expedientes.isai-dev.com/';
export const baseUrlServices = 'https://abogados-control-expedientes.isai-dev.com/services.php?serviceName=';